import React, { useState, useEffect, Fragment } from 'react';
import withConfirm from 'hooks/withConfirm';
import { STATUS_EXERCISE } from 'constant/timeline';
import Typography from '@material-ui/core/Typography';
import { toUserTimezone } from '../../../utils';
import { makeStyles } from '@material-ui/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from 'components/common/Button';

const STATUS_COLOR = {
  inprogress: '#FFAD0F',
  done: '#8ED76E',
  new: '#AAB5CE',
  noshow: '#DC143C',
};

const STATUS = {
  inprogress: 'In progress',
  done: 'Done',
  noshow: 'No Show',
};

const useStyles = makeStyles((theme) => ({
  taskItem: {
    'marginBottom': theme.spacing(2.5),
    '& .grid': {
      display: 'flex',
      alignItems: 'center',
      marginTop: 4,
    },
    '& .flex': {
      flex: 1,
    },
    '&:last-child': {
      marginBottom: 0,
    },
    '& a': {
      color: 'inherit',
      fontWeight: 500,
    },
  },
  scheduleActions: {
    'marginTop': theme.spacing(1),
    'display': 'flex',
    'justifyContent': 'space-between',
    '& a': {
      color: theme.palette.primary.main,
    },
    '& .cancel': {
      color: theme.palette.secondary.main,
      marginLeft: theme.spacing(1),
    },
  },
}));

const StatusSelect = ({ handleConfirm, initialStatus, onClose }) => {
  const [newStatus, setStatus] = useState(initialStatus);

  const onStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Change Status</DialogTitle>
      <DialogContent>
        <Select
          disableUnderline
          displayEmpty
          renderValue={(val) =>
            STATUS_EXERCISE.find((s) => s.value === val)?.label || 'Select'
          }
          value={newStatus}
          onChange={onStatusChange}
        >
          {STATUS_EXERCISE.map((i) => (
            <MenuItem key={i.value} value={i.value}>
              {i.label}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions style={{ padding: 20 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => handleConfirm(newStatus)} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const TaskItem = ({
  task,
  studentSub,
  user,
  student,
  onSchedule,
  onReschedule,
  onCancelMeeting,
  readOnly,
  disableView,
  onUpdate,
}) => {
  const classes = useStyles();
  const { id, status, due_date, exercise, response, student_milestone } = task;
  const { name } = exercise;
  const isDone = status === 'done';
  const noShow = status === 'noshow';
  const [showStatusModal, setShowModal] = useState(false);

  const onChangeStatus = (val) => onUpdate(id, { status: val });

  if (isDone || noShow) {
    return (
      <div className={classes.taskItem}>
        <div className="grid">
          <Typography variant="caption" color="textSecondary" className="flex">
            {student_milestone.name}
          </Typography>
          {due_date && (
            <Typography variant="caption" color="textSecondary">
              Scheduled{' '}
              {toUserTimezone(due_date, user.timezone).format(
                'MM-DD-YYYY hh:mm A z',
              )}
            </Typography>
          )}
        </div>
        <div className="grid">
          <Typography color="textPrimary" className="flex">
            {name}
          </Typography>
          <Typography variant="subtitle2" color="primary">
            {response?.canceled ? (
              <span style={{ color: 'red' }}>Canceled</span>
            ) : (
              <Typography
                color="textSecondary"
                variant="caption"
                style={{ color: STATUS_COLOR[status] || STATUS_COLOR.new }}
              >
                {STATUS[status] || status}
              </Typography>
            )}
          </Typography>
        </div>
      </div>
    );
  }
  return (
    <div className={classes.taskItem}>
      <div className="grid">
        <Typography variant="caption" color="textSecondary" className="flex">
          {student_milestone.name}
        </Typography>
        {due_date ? (
          <Typography variant="caption" color="textSecondary">
            Scheduled{' '}
            {toUserTimezone(due_date, user.timezone).format(
              'MM-DD-YYYY hh:mm A z',
            )}
          </Typography>
        ) : null}
      </div>
      <div className="grid">
        {due_date && !disableView ? (
          <Typography color="primary" className="flex">
            <a
              target="_blank"
              href={
                student.group
                  ? `/meeting/group/${student.group.group_id}`
                  : `/meeting/${studentSub}`
              }
            >
              {name}
            </a>
          </Typography>
        ) : (
          <Typography color="textPrimary" className="flex">
            {name}
          </Typography>
        )}
        {!readOnly && (
          <Typography variant="subtitle2" color="primary">
            {due_date && onReschedule ? (
              <div className={classes.scheduleActions}>
                <a
                  href="#"
                  onClick={() => setShowModal(true)}
                  style={{ marginRight: 16 }}
                >
                  Change Status
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onReschedule(task);
                  }}
                >
                  Reschedule Session
                </a>
                <a
                  className="cancel"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onCancelMeeting(task);
                  }}
                >
                  Cancel Session
                </a>
              </div>
            ) : (
              onSchedule && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onSchedule(task);
                  }}
                >
                  Schedule Meeting
                </a>
              )
            )}
          </Typography>
        )}
      </div>
      {showStatusModal && (
        <StatusSelect
          onClose={() => setShowModal(false)}
          initialStatus={status}
          handleConfirm={onChangeStatus}
        />
      )}
    </div>
  );
};

export default TaskItem;
